import classNames from "classnames";
import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import Select from "react-select";
import { toast } from "react-toastify";

import {
    Card,
    Col,
    Container,
    Row,
    CardBody,
    CardTitle,
    Label,
    Button,
    Form,
    Input,
    Nav,
    NavItem,
    TabContent,
    TabPane,
    CardText,
} from "reactstrap";
import { Addproperties } from "service/api";
import DatatableTables from "./DatatableTables";
import AdminGuard from "helpers/AuthType/AdminGuard";
const defaultvalue = {
    title: '',
    description: '',
    price: '',
    location: '',
    city: '',
    state: '',
    country: '',
    pin_code: '',
    property_type: '',
    property_details: '',
    bedrooms: '',
    bathrooms: '',
    area_sqft: '',
    year_built: '',
    festive_offer: '',
    available_units: '',
    offer_units: '',
    status: '',
    features: '',
    images: [],
    facilities: '',
    created_at: '',
    updated_at: '',
    is_featured: '',
    posted_by: '',
    contact_info: ''
}
const Addproperty = () => {
    const [property, setProperty] = useState(defaultvalue)
    const [customActiveTab, setcustomActiveTab] = useState("1");
    const [selectedPropertyType, setSelectedPropertyType] = useState(null);
    const [selectedStatus, setSelectedStatus] = useState(null);
    const [refreshTable, setRefreshTable] = useState(false);
    const [videoLinks, setVideoLinks] = useState([""]);
    const [Facilities, setFacilities] = useState([""]);
    const [Specifications, setSpecification] = useState([
        { category: "", detail: "" }
    ]);
    const [formRows, setFormRows] = useState([{ id: 1, bedrooms: "", bathrooms: "", superbuiltArea: "", price: "", plotArea: "", carpetArea: "", superbuiltArea: "", builtArea: "", plotAream: "", carpetAream: "", builtAream: "", superbuiltAream: "", plotAreaacr: "", carpetAreaacr: "", builtAreaacr: "", superbuiltAreaacr: "", plotAreavar: "", carpetAreavar: "", builtAreavar: "", superbuiltAreavar: "", }]);
    const handleInputChange = (id, field, value) => {
        setFormRows(prevRows => prevRows.map(row =>
            row.id === id ? { ...row, [field]: value } : row
        ));
    };
    const onAddFormRow = () => {
        const modifiedRows = [...formRows];
        modifiedRows.push({ id: modifiedRows.length + 1 });
        setFormRows(modifiedRows);
    };
    const onDeleteFormRow = id => {
        if (id !== 1) {
            var modifiedRows = [...formRows];
            modifiedRows = modifiedRows.filter(x => x["id"] !== id);
            setFormRows(modifiedRows);
        }
    };
    // Handle input change
    const handleVideoChange = (index, value) => {
        const newVideoLinks = [...videoLinks];
        newVideoLinks[index] = value;
        setVideoLinks(newVideoLinks);
    };
    // Add new input field
    const addVideoField = () => {
        setVideoLinks([...videoLinks, ""]);
    };
    // Remove input field
    const removeVideoField = (index) => {
        const newVideoLinks = videoLinks.filter((_, i) => i !== index);
        setVideoLinks(newVideoLinks);
    };
    const handleFacilityChange = (index, value) => {
        const newfacilities = [...Facilities];
        newfacilities[index] = value;
        setFacilities(newfacilities);
    };
    const addFacilityField = () => {
        setFacilities([...Facilities, ""]);
    };
    const removeFacitlityField = (index) => {
        const newfacilities = Facilities.filter((_, i) => i !== index);
        setFacilities(newfacilities);
    };

    const handleSpecificationChange = (index, field, value) => {
        const updated = [...Specifications];
        updated[index][field] = value;
        setSpecification(updated);
    };

    const addSpecificationField = () => {
        setSpecification([...Specifications, { category: "", detail: "" }]);
    };

    const removeSpecificationField = (index) => {
        const updated = Specifications.filter((_, i) => i !== index);
        setSpecification(updated);
    };
    const [formData, setFormData] = useState({
        images: [], // Store uploaded files
    });
    const [imagePreviews, setImagePreviews] = useState([]); // Store image preview URLs
    // Handle file upload

    // const handleFileUpload = (e) => {
    //     const files = Array.from(e.target.files);
    //     // Generate temporary URLs for image previews
    //     const previewUrls = files.map((file) => URL.createObjectURL(file));
    //     // Update state
    //     setFormData((prevData) => ({
    //         ...prevData,
    //         images: [...prevData.images, ...files], // Append new files to existing ones
    //     }));
    //     setImagePreviews((prevPreviews) => [...prevPreviews, ...previewUrls]); // Append new previews to existing ones
    // };

    const handleFileUpload = (e) => {
        const files = Array.from(e.target.files);
        const newImageObjects = files.map(file => ({ file, title: "" }));
        const previewUrls = files.map((file) => URL.createObjectURL(file));

        setFormData((prevData) => ({
            ...prevData,
            images: [...prevData.images, ...newImageObjects],
        }));
        setImagePreviews((prevPreviews) => [...prevPreviews, ...previewUrls]);
    };

    // Remove individual image preview
    // const removeImagePreview = (index) => {
    //     const updatedPreviews = imagePreviews.filter((_, i) => i !== index);
    //     const updatedFiles = formData.images.filter((_, i) => i !== index);

    //     setImagePreviews(updatedPreviews);
    //     setFormData((prevData) => ({
    //         ...prevData,
    //         images: updatedFiles,
    //     }));
    // };

    const removeImagePreview = (index) => {
        const updatedPreviews = imagePreviews.filter((_, i) => i !== index);
        const updatedImages = formData.images.filter((_, i) => i !== index);

        setImagePreviews(updatedPreviews);
        setFormData((prevData) => ({
            ...prevData,
            images: updatedImages,
        }));
    };

    // List of status options
    const statusOptions = [
        { value: "For Sale", label: "For Sale" },
        { value: "Ready To Move", label: "Ready To Move" },
        { value: "Sold", label: "Sold" },
        { value: "Re-Sale", label: "Re-Sale" },
        { value: "Under Construction", label: "Under Construction" },
        { value: "Pre-Sale", label: "Pre-Sale" },
        { value: "Rent", label: "Rent" },
        { value: "Leased", label: "Leased" },
        { value: "Pending Sale", label: "Pending Sale" },
        { value: "Off Market", label: "Off Market" },
        { value: "Foreclosure", label: "Foreclosure" },
        { value: "Auction", label: "Auction" },
        { value: "Reserved", label: "Reserved" },
        { value: "Coming Soon", label: "Coming Soon" },
        { value: "Under Renovation", label: "Under Renovation" },
        { value: "Expired Listing", label: "Expired Listing" },
        { value: "Withdrawn", label: "Withdrawn" },
        { value: "Active Option Contract", label: "Active Option Contract" },
        { value: "Hold", label: "Hold" },
        { value: "New Construction", label: "New Construction" },
        { value: "Relisted", label: "Relisted" },
        { value: "Price Reduced", label: "Price Reduced" },
    ];

    // List of property types
    const propertyTypes = [
        { value: "Apartment", label: "Apartment" },
        { value: "Villa", label: "Villa" },
        { value: "Independent House", label: "Independent House" },
        { value: "Studio Apartment", label: "Studio Apartment" },
        { value: "Penthouse", label: "Penthouse" },
        { value: "Townhouse", label: "Townhouse" },
        { value: "Cottage", label: "Cottage" },
        { value: "Bungalow", label: "Bungalow" },
        { value: "Farmhouse", label: "Farmhouse" },
        { value: "Condominium", label: "Condominium" },
        { value: "Loft", label: "Loft" },
        { value: "Serviced Apartment", label: "Serviced Apartment" },
        { value: "Office Space", label: "Office Space" },
        { value: "Retail Space", label: "Retail Space" },
        { value: "Warehouse", label: "Warehouse" },
        { value: "Industrial Property", label: "Industrial Property" },
        { value: "Shop", label: "Shop" },
        { value: "Showroom", label: "Showroom" },
        { value: "Hotel", label: "Hotel" },
        { value: "Restaurant", label: "Restaurant" },
        { value: "Agricultural Land", label: "Agricultural Land" },
        { value: "Plot/Land", label: "Plot/Land" },
        { value: "Beach House", label: "Beach House" },
        { value: "Mountain Cabin", label: "Mountain Cabin" },
        { value: "Vacation Home", label: "Vacation Home" },
        { value: "Luxury Estate", label: "Luxury Estate" },
        { value: "Heritage Property", label: "Heritage Property" },
        { value: "Eco-Friendly Home", label: "Eco-Friendly Home" },
        { value: "Smart Home", label: "Smart Home" },
        { value: "Garage", label: "Garage" },
        { value: "Parking Space", label: "Parking Space" },
        { value: "Storage Unit", label: "Storage Unit" },
        { value: "Mixed-Use Property", label: "Mixed-Use Property" },
    ];
    // Handle property type selection
    const handlePropertyTypeChange = (selectedOption) => {
        setSelectedPropertyType(selectedOption);
        // You can also store the selected value in your form state if needed
        console.log("Selected Property Type:", selectedOption);
    };
    // Handle status selection
    const handleStatusChange = (selectedOption) => {
        setSelectedStatus(selectedOption);
        // You can also store the selected value in your form state if needed
        console.log("Selected status:", selectedOption);
    };
    const toggleCustom = tab => {
        if (customActiveTab !== tab) {
            setcustomActiveTab(tab);
        }
    };
    // Handle text input changes
    const onValueChange = (e) => {
        setProperty({ ...property, [e.target.name]: e.target.value });
    };
    const saveproperty = async (e) => {
        e.preventDefault();
        const formPayload = new FormData();
        // Append property details
        formPayload.append("title", property.title);
        formPayload.append("description", property.description);
        formPayload.append("price", property.price);
        formPayload.append("location", property.location);
        formPayload.append("city", property.city);
        formPayload.append("state", property.state);
        formPayload.append("country", property.country);
        formPayload.append("pin_code", property.pin_code);
        formPayload.append("property_type", selectedPropertyType?.value || "");
        formPayload.append("bedrooms", property.bedrooms);
        formPayload.append("bathrooms", property.bathrooms);
        formPayload.append("area_sqft", property.area_sqft);
        formPayload.append("year_built", property.year_built);
        formPayload.append("festive_offer", property.festive_offer);
        formPayload.append("available_units", property.available_units);
        formPayload.append("offer_units", property.offer_units);
        formPayload.append("status", selectedStatus?.value || "");
        formPayload.append("features", property.features);
        formPayload.append("is_featured", property.is_featured);
        formPayload.append("posted_by", property.posted_by);
        formPayload.append("contact_info", property.contact_info);
        // Append formRows as JSON
        formPayload.append("property_details", JSON.stringify(formRows));
        // Ensure images exist before calling forEach
        if (Array.isArray(formData.images) && formData.images.length > 0) {
            formData.images.forEach((imgObj, index) => {
                formPayload.append(`images`, imgObj.file); // file
                formPayload.append(`image_titles[]`, imgObj.title); // title
            });

            // formData.images.forEach((image) => {
            //     formPayload.append("images", image);
            // });
        }
        if (Array.isArray(videoLinks) && videoLinks.length > 0) {
            formPayload.append("video_links", JSON.stringify(videoLinks));
        }
        if (Array.isArray(Facilities) && Facilities.length > 0) {
            formPayload.append("facilities", JSON.stringify(Facilities));
        }
        if (Array.isArray(Specifications) && Specifications.length > 0) {
            formPayload.append("specifications", JSON.stringify(Specifications));
        }

        // Show a loading toast
        const loadingToast = toast.loading("Saving property...");

        try {
            const response = await Addproperties(formPayload);

            toast.update(loadingToast, {
                render: "Property saved successfully!",
                type: "success",
                isLoading: false,
                autoClose: 3000
            });

            console.log("Property saved successfully:", response.data);
        } catch (error) {
            toast.update(loadingToast, {
                render: "Error saving property. Please try again.",
                type: "error",
                isLoading: false,
                autoClose: 3000
            });

            console.error("Error saving property:", error);
        }
    };
    return (
        <AdminGuard>
            <React.Fragment>
                <div className="page-content" style={{ color: "#fff", fontFamily: "'Roboto', sans-serif" }}>
                    <Container fluid={true} className="py-1">
                        <Row className="justify-content-center">
                            <Col xl={12} lg={6} md={12}>
                                <Card style={{ backgroundColor: '#1E253A' }}>
                                    <CardBody>
                                        <CardTitle className="h3">Add Property</CardTitle>
                                        <Nav tabs className="nav-tabs-custom nav-justified ">
                                            <NavItem>
                                                <NavLink
                                                    style={{ cursor: "pointer" }}
                                                    className={classNames({
                                                        active: customActiveTab === "1",
                                                    })}
                                                    onClick={() => {
                                                        toggleCustom("1");
                                                    }}
                                                >
                                                    <span className="d-block d-sm-none">
                                                        <i className="fas fa-home"></i>
                                                    </span>
                                                    <span className="d-none d-sm-block text-light">Property Details</span>
                                                </NavLink>
                                            </NavItem>
                                            <NavItem>
                                                <NavLink
                                                    style={{ cursor: "pointer" }}
                                                    className={classNames({
                                                        active: customActiveTab === "2",
                                                    })}
                                                    onClick={() => {
                                                        toggleCustom("2");
                                                    }}
                                                >
                                                    <span className="d-block d-sm-none">
                                                        <i className="far fa-user"></i>
                                                    </span>
                                                    <span className="d-none d-sm-block text-light">Facilities</span>
                                                </NavLink>
                                            </NavItem>
                                        </Nav>
                                        <TabContent
                                            activeTab={customActiveTab}
                                            className="p-3 text-muted"
                                        >
                                            <TabPane tabId="1">
                                                <Form encType="multipart/form-data">
                                                    <Row className="text-light">
                                                        <Col sm="2">
                                                            <div className="mb-3">
                                                                <Label htmlFor="title">Title</Label>
                                                                <Input
                                                                    type="text"
                                                                    className="form-control"
                                                                    id="title"
                                                                    name="title"
                                                                    onChange={(e) => onValueChange(e)}
                                                                    placeholder="Title you want to display in URL"
                                                                    style={{ backgroundColor: "rgba(255, 255, 255, 0.2)", color: "#fff" }}
                                                                />
                                                            </div>
                                                        </Col>
                                                        <Col sm="2">
                                                            <div className="mb-3">
                                                                <Label htmlFor="title">Price Range</Label>
                                                                <Input
                                                                    type="text"
                                                                    className="form-control"
                                                                    id="price"
                                                                    name="price"
                                                                    onChange={(e) => onValueChange(e)}
                                                                    placeholder="Price"
                                                                    style={{ backgroundColor: "rgba(255, 255, 255, 0.2)", color: "#fff" }}
                                                                />
                                                            </div>
                                                        </Col>
                                                        <Col sm="2">
                                                            <div className="mb-3">
                                                                <Label htmlFor="title">Location</Label>
                                                                <Input
                                                                    type="text"
                                                                    className="form-control"
                                                                    id="location"
                                                                    name="location"
                                                                    onChange={(e) => onValueChange(e)}
                                                                    placeholder="Location"
                                                                    style={{ backgroundColor: "rgba(255, 255, 255, 0.2)", color: "#fff" }}
                                                                />
                                                            </div>
                                                        </Col>
                                                        <Col sm="2">
                                                            <div className="mb-3">
                                                                <Label htmlFor="title">City</Label>
                                                                <Input
                                                                    type="text"
                                                                    className="form-control"
                                                                    id="City"
                                                                    name="city"
                                                                    placeholder="city"
                                                                    onChange={(e) => onValueChange(e)}
                                                                    style={{ backgroundColor: "rgba(255, 255, 255, 0.2)", color: "#fff" }}
                                                                />
                                                            </div>
                                                        </Col>
                                                        <Col sm="2">
                                                            <div className="mb-3">
                                                                <Label htmlFor="title">State</Label>
                                                                <Input
                                                                    type="text"
                                                                    className="form-control"
                                                                    id="state"
                                                                    name="state"
                                                                    placeholder="State"
                                                                    onChange={(e) => onValueChange(e)}
                                                                    style={{ backgroundColor: "rgba(255, 255, 255, 0.2)", color: "#fff" }}
                                                                />
                                                            </div>
                                                        </Col>
                                                        <Col sm="2">
                                                            <div className="mb-3">
                                                                <Label htmlFor="title">Country</Label>
                                                                <Input
                                                                    type="text"
                                                                    className="form-control"
                                                                    id="Country"
                                                                    name="country"
                                                                    placeholder="country"
                                                                    onChange={(e) => onValueChange(e)}
                                                                    style={{ backgroundColor: "rgba(255, 255, 255, 0.2)", color: "#fff" }}
                                                                />
                                                            </div>
                                                        </Col>
                                                        <Col sm="2">
                                                            <div className="mb-3">
                                                                <Label htmlFor="title">Pin Code</Label>
                                                                <Input
                                                                    type="text"
                                                                    className="form-control"
                                                                    id="pin_code"
                                                                    name="pin_code"
                                                                    placeholder="Pin-Code"
                                                                    onChange={(e) => onValueChange(e)}
                                                                    style={{ backgroundColor: "rgba(255, 255, 255, 0.2)", color: "#fff" }}
                                                                />
                                                            </div>
                                                        </Col>
                                                        <Col sm="4">
                                                            <div className="mb-3">
                                                                <Label htmlFor="propertytype">Property Type</Label>
                                                                <Select
                                                                    id="property_type"
                                                                    name="property_type"
                                                                    options={propertyTypes}
                                                                    value={selectedPropertyType}
                                                                    onChange={(e) => {
                                                                        handlePropertyTypeChange(e);
                                                                        onValueChange(e)
                                                                    }}
                                                                    placeholder="Select Property Type"
                                                                    isSearchable // Enable search functionality
                                                                    styles={{
                                                                        control: (base) => ({
                                                                            ...base,
                                                                            backgroundColor: "rgba(255, 255, 255, 0.2)",
                                                                            color: "#fff",
                                                                            border: "none",
                                                                        }),
                                                                        menu: (base) => ({
                                                                            ...base,
                                                                            backgroundColor: "#333",
                                                                            color: "#fff",
                                                                        }),
                                                                        option: (base, { isFocused }) => ({
                                                                            ...base,
                                                                            backgroundColor: isFocused ? "#555" : "#333",
                                                                            color: "#fff",
                                                                        }),
                                                                        singleValue: (base) => ({
                                                                            ...base,
                                                                            color: "#fff",
                                                                        }),
                                                                        input: (base) => ({
                                                                            ...base,
                                                                            color: "#fff",
                                                                        }),
                                                                    }}
                                                                />
                                                            </div>
                                                        </Col>
                                                        <Col sm="4">
                                                            <div className="mb-3">
                                                                <Label htmlFor="status">Status</Label>
                                                                <Select
                                                                    name="status"
                                                                    options={statusOptions}
                                                                    value={selectedStatus}
                                                                    onChange={(e) => {
                                                                        handleStatusChange(e);
                                                                        onValueChange(e)
                                                                    }}
                                                                    placeholder="Select Status"
                                                                    isSearchable // Enable search functionality
                                                                    styles={{
                                                                        control: (base) => ({
                                                                            ...base,
                                                                            backgroundColor: "rgba(255, 255, 255, 0.2)",
                                                                            color: "#fff",
                                                                            border: "none",
                                                                        }),
                                                                        menu: (base) => ({
                                                                            ...base,
                                                                            backgroundColor: "#333",
                                                                            color: "#fff",
                                                                        }),
                                                                        option: (base, { isFocused }) => ({
                                                                            ...base,
                                                                            backgroundColor: isFocused ? "#555" : "#333",
                                                                            color: "#fff",
                                                                        }),
                                                                        singleValue: (base) => ({
                                                                            ...base,
                                                                            color: "#fff",
                                                                        }),
                                                                        input: (base) => ({
                                                                            ...base,
                                                                            color: "#fff",
                                                                        }),
                                                                    }}
                                                                />
                                                            </div>
                                                        </Col>
                                                        <Col sm="2">
                                                            <div className="mb-3">
                                                                <Label htmlFor="title">Posted By</Label>
                                                                <Input
                                                                    type="text"
                                                                    className="form-control"
                                                                    id="posted_by"
                                                                    name="posted_by"
                                                                    onChange={(e) => onValueChange(e)}
                                                                    placeholder="Posted By"
                                                                    style={{ backgroundColor: "rgba(255, 255, 255, 0.2)", color: "#fff" }}
                                                                />
                                                            </div>
                                                        </Col>
                                                        <Col sm="2">
                                                            <div className="mb-3">
                                                                <Label htmlFor="title">Year Built</Label>
                                                                <Input
                                                                    type="text"
                                                                    className="form-control"
                                                                    id="year_built"
                                                                    name="year_built"
                                                                    onChange={(e) => onValueChange(e)}
                                                                    placeholder="Year Built"
                                                                    style={{ backgroundColor: "rgba(255, 255, 255, 0.2)", color: "#fff" }}
                                                                />
                                                            </div>
                                                        </Col>
                                                        <Col md={4}>
                                                            <div className="mb-3">
                                                                <Label htmlFor="festive_offer">Festive Module ?</Label>
                                                                <select
                                                                    id="festive_offer"
                                                                    name="festive_offer"
                                                                    className="form-control"
                                                                    onChange={(e) => {
                                                                        onValueChange(e);
                                                                        const availableDiv = document.getElementById("available_units_div");
                                                                        const availableDiv2 = document.getElementById("available_units_div2");
                                                                        if (availableDiv) {
                                                                            if (e.target.value === "yes") {
                                                                                availableDiv.style.display = "block";
                                                                                availableDiv2.style.display = "block";
                                                                            } else {
                                                                                availableDiv.style.display = "none";
                                                                                availableDiv2.style.display = "none";
                                                                            }
                                                                        }
                                                                    }}
                                                                >
                                                                    <option defaultValue>Choose...</option>
                                                                    <option>yes</option>
                                                                    <option>no</option>
                                                                </select>
                                                            </div>
                                                        </Col>

                                                        <Col md={2}>
                                                            <div className="mb-3" id="available_units_div" style={{ display: "none" }}>
                                                                <Label htmlFor="available_units">Available units</Label>
                                                                <Input
                                                                    type="text"
                                                                    className="form-control"
                                                                    id="available_units"
                                                                    name="available_units"
                                                                    onChange={(e) => onValueChange(e)}
                                                                    style={{ backgroundColor: "rgba(255, 255, 255, 0.2)", color: "#fff" }}
                                                                />
                                                            </div>
                                                        </Col>

                                                        <Col md={2}>
                                                            <div className="mb-3" id="available_units_div2" style={{ display: "none" }}>
                                                                <Label htmlFor="offer_units">Offer units</Label>
                                                                <Input
                                                                    type="text"
                                                                    className="form-control"
                                                                    id="offer_units"
                                                                    onChange={(e) => onValueChange(e)}
                                                                    name="offer_units"
                                                                    style={{ backgroundColor: "rgba(255, 255, 255, 0.2)", color: "#fff" }}
                                                                />
                                                            </div>
                                                        </Col>
                                                        <hr style={{ borderTop: "2px solid white", opacity: 1 }} />

                                                        <div>
                                                            {(formRows || []).map((formRow, key) => (
                                                                <Row key={key}>
                                                                    <Col lg={2} className="mb-3">
                                                                        <label htmlFor="name">Bedrooms</label>
                                                                        <input
                                                                            style={{ backgroundColor: "rgba(255, 255, 255, 0.2)", color: "#fff" }}

                                                                            type="text"
                                                                            id="bedroom"
                                                                            name="bedroom"
                                                                            className="form-control"
                                                                            placeholder="bedrooms"
                                                                            onChange={(e) => handleInputChange(formRow.id, "bedrooms", e.target.value)}
                                                                        />
                                                                    </Col>

                                                                    <Col lg={2} className="mb-3">
                                                                        <label htmlFor="email">Bathrooms</label>
                                                                        <input
                                                                            style={{ backgroundColor: "rgba(255, 255, 255, 0.2)", color: "#fff" }}

                                                                            type="text"
                                                                            id="bathrooms"
                                                                            name="bathrooms"
                                                                            className="form-control"
                                                                            placeholder="bathrooms"
                                                                            onChange={(e) => handleInputChange(formRow.id, "bathrooms", e.target.value)}
                                                                        />
                                                                    </Col>

                                                                    <Col lg={2} className="mb-3">
                                                                        <label htmlFor="subject">Price</label>
                                                                        <input
                                                                            style={{ backgroundColor: "rgba(255, 255, 255, 0.2)", color: "#fff" }}

                                                                            type="text"
                                                                            id="price"
                                                                            name="price"
                                                                            className="form-control"
                                                                            placeholder="price"
                                                                            onChange={(e) => handleInputChange(formRow.id, "price", e.target.value)}
                                                                        />
                                                                    </Col>

                                                                    <Col lg={2} className="mb-3">
                                                                        <label htmlFor="resume">Plot area (square feet)</label>
                                                                        <input
                                                                            style={{ backgroundColor: "rgba(255, 255, 255, 0.2)", color: "#fff" }}
                                                                            type="text"
                                                                            name="plotArea"
                                                                            className="form-control"
                                                                            id="plotArea"
                                                                            onChange={(e) => handleInputChange(formRow.id, "plotArea", e.target.value)}
                                                                        />
                                                                    </Col>

                                                                    <Col lg={2} className="mb-3">
                                                                        <label htmlFor="message">Carpet area (square feet)</label>
                                                                        <input
                                                                            style={{ backgroundColor: "rgba(255, 255, 255, 0.2)", color: "#fff" }}
                                                                            id="carpetArea"
                                                                            name="carpetArea"
                                                                            className="form-control"
                                                                            placeholder="Carpet Area"
                                                                            onChange={(e) => handleInputChange(formRow.id, "carpetArea", e.target.value)}

                                                                        ></input>
                                                                    </Col>
                                                                    <Col lg={2} className="mb-3">
                                                                        <label htmlFor="message">Built-up area (square feet)</label>
                                                                        <input
                                                                            style={{ backgroundColor: "rgba(255, 255, 255, 0.2)", color: "#fff" }}
                                                                            id="builtArea"
                                                                            name="builtArea"
                                                                            className="form-control"
                                                                            placeholder="Built up Area"
                                                                            onChange={(e) => handleInputChange(formRow.id, "builtArea", e.target.value)}

                                                                        ></input>
                                                                    </Col>
                                                                    <Col lg={2} className="mb-3">
                                                                        <label htmlFor="message">super built-up area (square feet)</label>
                                                                        <input
                                                                            style={{ backgroundColor: "rgba(255, 255, 255, 0.2)", color: "#fff" }}

                                                                            id="superbuiltArea"
                                                                            name="superbuiltArea"
                                                                            className="form-control"
                                                                            placeholder="Super built-up Area"
                                                                            onChange={(e) => handleInputChange(formRow.id, "superbuiltArea", e.target.value)}

                                                                        ></input>
                                                                    </Col>
                                                                    <Col lg={2} className="mb-3">
                                                                        <label htmlFor="resume">Plot area (meter)</label>
                                                                        <input
                                                                            style={{ backgroundColor: "rgba(255, 255, 255, 0.2)", color: "#fff" }}
                                                                            type="text"
                                                                            name="plotAream"
                                                                            className="form-control"
                                                                            id="plotArea"
                                                                            onChange={(e) => handleInputChange(formRow.id, "plotAream", e.target.value)}
                                                                        />
                                                                    </Col>

                                                                    <Col lg={2} className="mb-3">
                                                                        <label htmlFor="message">Carpet area (meter)</label>
                                                                        <input
                                                                            style={{ backgroundColor: "rgba(255, 255, 255, 0.2)", color: "#fff" }}
                                                                            id="carpetArea"
                                                                            name="carpetAream"
                                                                            className="form-control"
                                                                            placeholder="Carpet Area"
                                                                            onChange={(e) => handleInputChange(formRow.id, "carpetAream", e.target.value)}
                                                                        ></input>
                                                                    </Col>
                                                                    <Col lg={2} className="mb-3">
                                                                        <label htmlFor="message">Built-up area (meter)</label>
                                                                        <input
                                                                            style={{ backgroundColor: "rgba(255, 255, 255, 0.2)", color: "#fff" }}
                                                                            id="builtArea"
                                                                            name="builtAream"
                                                                            className="form-control"
                                                                            placeholder="Built up Area"
                                                                            onChange={(e) => handleInputChange(formRow.id, "builtAream", e.target.value)}

                                                                        ></input>
                                                                    </Col>
                                                                    <Col lg={2} className="mb-3">
                                                                        <label htmlFor="message">super built-up area (meter)</label>
                                                                        <input
                                                                            style={{ backgroundColor: "rgba(255, 255, 255, 0.2)", color: "#fff" }}

                                                                            id="superbuiltArea"
                                                                            name="superbuiltAream"
                                                                            className="form-control"
                                                                            placeholder="Super built-up Area"
                                                                            onChange={(e) => handleInputChange(formRow.id, "superbuiltAream", e.target.value)}
                                                                        ></input>
                                                                    </Col>
                                                                    <Col lg={2} className="mb-3">
                                                                        <label htmlFor="resume">Plot area (acr)</label>
                                                                        <input
                                                                            style={{ backgroundColor: "rgba(255, 255, 255, 0.2)", color: "#fff" }}
                                                                            type="text"
                                                                            name="plotAreaacr"
                                                                            className="form-control"
                                                                            id="plotArea"
                                                                            onChange={(e) => handleInputChange(formRow.id, "plotAreaacr", e.target.value)}

                                                                        />
                                                                    </Col>

                                                                    <Col lg={2} className="mb-3">
                                                                        <label htmlFor="message">Carpet area (acr)</label>
                                                                        <input
                                                                            style={{ backgroundColor: "rgba(255, 255, 255, 0.2)", color: "#fff" }}
                                                                            id="carpetArea"
                                                                            name="carpetAreaacr"
                                                                            className="form-control"
                                                                            placeholder="Carpet Area"
                                                                            onChange={(e) => handleInputChange(formRow.id, "carpetAreaacr", e.target.value)}
                                                                        ></input>
                                                                    </Col>
                                                                    <Col lg={2} className="mb-3">
                                                                        <label htmlFor="message">Built-up area (acr)</label>
                                                                        <input
                                                                            style={{ backgroundColor: "rgba(255, 255, 255, 0.2)", color: "#fff" }}
                                                                            id="builtArea"
                                                                            name="builtAreaacr"
                                                                            className="form-control"
                                                                            placeholder="Built up Area"
                                                                            onChange={(e) => handleInputChange(formRow.id, "builtAreaacr", e.target.value)}
                                                                        ></input>
                                                                    </Col>
                                                                    <Col lg={2} className="mb-3">
                                                                        <label htmlFor="message">super built-up area (acr)</label>
                                                                        <input
                                                                            style={{ backgroundColor: "rgba(255, 255, 255, 0.2)", color: "#fff" }}

                                                                            id="superbuiltArea"
                                                                            name="superbuiltAreaacr"
                                                                            className="form-control"
                                                                            placeholder="Super built-up Area"
                                                                            onChange={(e) => handleInputChange(formRow.id, "superbuiltAreaacr", e.target.value)}
                                                                        ></input>
                                                                    </Col>
                                                                    <Col lg={2} className="mb-3">
                                                                        <label htmlFor="resume">Plot area (var)</label>
                                                                        <input
                                                                            style={{ backgroundColor: "rgba(255, 255, 255, 0.2)", color: "#fff" }}
                                                                            type="text"
                                                                            name="plotAreavar"
                                                                            className="form-control"
                                                                            id="plotArea"
                                                                            onChange={(e) => handleInputChange(formRow.id, "plotAreavar", e.target.value)}

                                                                        />
                                                                    </Col>

                                                                    <Col lg={2} className="mb-3">
                                                                        <label htmlFor="message">Carpet area (var)</label>
                                                                        <input
                                                                            style={{ backgroundColor: "rgba(255, 255, 255, 0.2)", color: "#fff" }}
                                                                            id="carpetArea"
                                                                            name="carpetAreavar"
                                                                            className="form-control"
                                                                            placeholder="Carpet Area"
                                                                            onChange={(e) => handleInputChange(formRow.id, "carpetAreavar", e.target.value)}
                                                                        ></input>
                                                                    </Col>
                                                                    <Col lg={2} className="mb-3">
                                                                        <label htmlFor="message">Built-up area (var)</label>
                                                                        <input
                                                                            style={{ backgroundColor: "rgba(255, 255, 255, 0.2)", color: "#fff" }}
                                                                            id="builtArea"
                                                                            name="builtAreavar"
                                                                            className="form-control"
                                                                            placeholder="Built up Area"
                                                                            onChange={(e) => handleInputChange(formRow.id, "builtAreavar", e.target.value)}
                                                                        ></input>
                                                                    </Col>
                                                                    <Col lg={2} className="mb-3">
                                                                        <label htmlFor="message">super built-up area (var)</label>
                                                                        <input
                                                                            style={{ backgroundColor: "rgba(255, 255, 255, 0.2)", color: "#fff" }}

                                                                            id="superbuiltArea"
                                                                            name="superbuiltAreavar"
                                                                            className="form-control"
                                                                            placeholder="Super built-up Area"
                                                                            onChange={(e) => handleInputChange(formRow.id, "superbuiltAreavar", e.target.value)}
                                                                        ></input>
                                                                    </Col>

                                                                    <Col lg={2} className="align-self-center">
                                                                        <div className="d-grid">
                                                                            <input
                                                                                type="button"
                                                                                className="btn btn-primary"
                                                                                value="Delete"
                                                                                onClick={() => onDeleteFormRow(formRow.id)}
                                                                            />
                                                                        </div>
                                                                    </Col>
                                                                    <hr style={{ borderTop: "2px solid white", opacity: 1 }} />

                                                                </Row>
                                                            ))}
                                                        </div>
                                                        <Col lg={2} className="align-self-center">
                                                            <div className="d-grid">
                                                                <input
                                                                    type="button"
                                                                    className="btn btn-success mt-3 mt-lg-0 mb-2"
                                                                    value="Add"
                                                                    onClick={() => onAddFormRow()}
                                                                />
                                                            </div>
                                                        </Col>

                                                    </Row>
                                                    <Row className="text-light">
                                                        <Col sm="5">
                                                            <div className="mb-3">
                                                                <Label htmlFor="title">Key POints</Label>
                                                                <Input
                                                                    type="text"
                                                                    className="form-control"
                                                                    id="features"
                                                                    name="features"
                                                                    onChange={(e) => onValueChange(e)}
                                                                    placeholder="Features"
                                                                    style={{ backgroundColor: "rgba(255, 255, 255, 0.2)", color: "#fff" }}
                                                                />
                                                            </div>
                                                        </Col>
                                                        <Col sm="6">
                                                            <div className="mb-3">
                                                                <Label>Facilities:</Label>
                                                                {Facilities.map((link, index) => (
                                                                    <div key={index} className="d-flex mb-2">
                                                                        <Input
                                                                            type="text"
                                                                            className="form-control"
                                                                            placeholder="Enter Facilities"
                                                                            value={link}
                                                                            onChange={(e) => handleFacilityChange(index, e.target.value)}
                                                                            style={{ backgroundColor: "rgba(255, 255, 255, 0.2)", color: "#fff" }}
                                                                        />
                                                                        <Button color="danger" onClick={() => removeFacitlityField(index)} className="ms-2">
                                                                            ❌
                                                                        </Button>
                                                                    </div>
                                                                ))}
                                                                <Button color="primary" onClick={addFacilityField}>
                                                                    ➕ Add Another Facility
                                                                </Button>
                                                            </div>
                                                        </Col>
                                                        <Col sm="6">
                                                            <div className="mb-3">
                                                                <Label>Specifications:</Label>
                                                                {Specifications.map((spec, index) => (
                                                                    <div key={index} className="d-flex flex-wrap mb-2 gap-2">
                                                                        <Input
                                                                            type="text"
                                                                            placeholder="Category"
                                                                            value={spec.category}
                                                                            onChange={(e) => handleSpecificationChange(index, "category", e.target.value)}
                                                                            className="form-control"
                                                                            style={{ backgroundColor: "rgba(255, 255, 255, 0.2)", color: "#fff", flex: 1 }}
                                                                        />
                                                                        <Input
                                                                            type="text"
                                                                            placeholder="Detail"
                                                                            value={spec.detail}
                                                                            onChange={(e) => handleSpecificationChange(index, "detail", e.target.value)}
                                                                            className="form-control"
                                                                            style={{ backgroundColor: "rgba(255, 255, 255, 0.2)", color: "#fff", flex: 1 }}
                                                                        />
                                                                        <Button color="danger" onClick={() => removeSpecificationField(index)}>
                                                                            ❌
                                                                        </Button>
                                                                    </div>
                                                                ))}
                                                                <Button color="primary" onClick={addSpecificationField}>
                                                                    ➕ Add Another Specification
                                                                </Button>
                                                            </div>
                                                        </Col>

                                                        <Col sm="5">
                                                            <div className="mb-3">
                                                                <Label htmlFor="title">Other Facilities</Label>
                                                                <Input
                                                                    type="text"
                                                                    className="form-control"
                                                                    id="facilities"
                                                                    name="facilities"
                                                                    onChange={(e) => onValueChange(e)}

                                                                    placeholder="Facilities"
                                                                    style={{ backgroundColor: "rgba(255, 255, 255, 0.2)", color: "#fff" }}
                                                                />
                                                            </div>
                                                        </Col>
                                                        <Col sm="6">
                                                            <div>
                                                                <label>Images:</label>
                                                                <input
                                                                    className="form-control"
                                                                    type="file"
                                                                    name="images"
                                                                    multiple
                                                                    onChange={handleFileUpload}
                                                                    style={{ backgroundColor: "rgba(255, 255, 255, 0.2)", color: "#fff" }}
                                                                />
                                                            </div>
                                                        </Col>
                                                        <Col sm="6">
                                                            <div className="mb-3">
                                                                <Label htmlFor="title">Description</Label>
                                                                <Input
                                                                    type="textarea"
                                                                    className="form-control"
                                                                    id="description"
                                                                    name="description"
                                                                    onChange={(e) => onValueChange(e)}
                                                                    placeholder="Description"
                                                                    style={{ backgroundColor: "rgba(255, 255, 255, 0.2)", color: "#fff" }}
                                                                />
                                                            </div>
                                                        </Col>
                                                        {/* Image Previews */}
                                                        <Col sm="12">
                                                            <div style={{ marginTop: "20px" }}>
                                                                <h5>Selected Images:</h5>
                                                                <div style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}>
                                                                    {formData.images.map((imgObj, index) => (
                                                                        <div key={index} style={{ width: "150px", color: "#fff" }}>
                                                                            <img
                                                                                src={imagePreviews[index]}
                                                                                alt={`preview-${index}`}
                                                                                style={{ width: "100%", height: "100px", objectFit: "cover" }}
                                                                            />
                                                                            <input
                                                                                type="text"
                                                                                placeholder="Image Title"
                                                                                value={imgObj.title}
                                                                                onChange={(e) => {
                                                                                    const updated = [...formData.images];
                                                                                    updated[index].title = e.target.value;
                                                                                    setFormData({ ...formData, images: updated });
                                                                                }}
                                                                                className="form-control mt-1"
                                                                                style={{ backgroundColor: "rgba(255,255,255,0.2)", color: "#fff" }}
                                                                            />
                                                                            <button type="button" className="btn btn-danger btn-sm mt-1" onClick={() => removeImagePreview(index)}>
                                                                                Remove
                                                                            </button>
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            </div>
                                                        </Col>

                                                        {/* <Col sm="12">
                                                        <div style={{ marginTop: "20px" }}>
                                                            <h5>Selected Images:</h5>
                                                            <div style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}>
                                                                {imagePreviews.map((preview, index) => (
                                                                    <div
                                                                        key={index}
                                                                        style={{ width: "100px", height: "100px", overflow: "hidden", position: "relative" }}
                                                                    >
                                                                        <img
                                                                            src={preview}
                                                                            alt={`Preview ${index}`}
                                                                            style={{ width: "100%", height: "100%", objectFit: "cover" }}
                                                                        />
                                                                        <button
                                                                            onClick={() => removeImagePreview(index)}
                                                                            style={{
                                                                                position: "absolute",
                                                                                top: "5px",
                                                                                right: "5px",
                                                                                background: "red",
                                                                                color: "white",
                                                                                border: "none",
                                                                                borderRadius: "50%",
                                                                                cursor: "pointer",
                                                                            }}
                                                                        >
                                                                            ×
                                                                        </button>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </div>
                                                    </Col> */}
                                                        {/* YouTube Video Links */}
                                                        <Col sm="6">
                                                            <div className="mb-3">
                                                                <Label>YouTube Videos:</Label>
                                                                {videoLinks.map((link, index) => (
                                                                    <div key={index} className="d-flex mb-2">
                                                                        <Input
                                                                            type="text"
                                                                            className="form-control"
                                                                            placeholder="Enter YouTube video link"
                                                                            value={link}
                                                                            onChange={(e) => handleVideoChange(index, e.target.value)}
                                                                            style={{ backgroundColor: "rgba(255, 255, 255, 0.2)", color: "#fff" }}
                                                                        />
                                                                        <Button color="danger" onClick={() => removeVideoField(index)} className="ms-2">
                                                                            ❌
                                                                        </Button>
                                                                    </div>
                                                                ))}
                                                                <Button color="primary" onClick={addVideoField}>
                                                                    ➕ Add Another Video
                                                                </Button>
                                                            </div>
                                                        </Col>
                                                        <Col sm="6 mt-4">
                                                            <div className="text-center">
                                                                <button
                                                                    type="submit"
                                                                    onClick={saveproperty}
                                                                    style={{
                                                                        width: "100%",
                                                                        fontWeight: "600",
                                                                        background: "linear-gradient(to right, #6a11cb, #2575fc)",
                                                                        border: "none",
                                                                        padding: "10px 20px",
                                                                        borderRadius: "25px",
                                                                    }}
                                                                >
                                                                    Save
                                                                </button>
                                                            </div>
                                                        </Col>
                                                    </Row>


                                                </Form>
                                            </TabPane>

                                            <TabPane tabId="2">
                                                <Form>
                                                    <Row>
                                                        <Col sm="6">
                                                            <div className="mb-3">
                                                                <Label htmlFor="title">Facilities</Label>
                                                                <Input
                                                                    type="text"
                                                                    className="form-control"
                                                                    id="name"
                                                                    name="name"
                                                                    placeholder="Mention Facilities"
                                                                    style={{ backgroundColor: "rgba(255, 255, 255, 0.2)", color: "#fff" }}
                                                                />
                                                            </div>
                                                        </Col>
                                                        <Col sm="6 mt-4">
                                                            <div className="text-center">
                                                                <button
                                                                    type="submit"
                                                                    style={{
                                                                        width: "100%",
                                                                        fontWeight: "600",
                                                                        background: "linear-gradient(to right, #6a11cb, #2575fc)",
                                                                        border: "none",
                                                                        padding: "10px 20px",
                                                                        borderRadius: "25px",
                                                                    }}
                                                                >
                                                                    Save
                                                                </button>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </Form>
                                            </TabPane>
                                            {/* <TabPane tabId="3">
                                            <Form encType="multipart/form-data">
                                                <Row>
                                                    <Col sm="6">
                                                        <div className="mb-3">
                                                            <Label htmlFor="title">Features</Label>
                                                            <Input
                                                                type="text"
                                                                className="form-control"
                                                                id="Features"
                                                                name="Features"
                                                                placeholder="Mention Features"
                                                                style={{ backgroundColor: "rgba(255, 255, 255, 0.2)", color: "#fff" }}
                                                            />
                                                        </div>
                                                    </Col>
                                                    <Col sm="6 mt-4">
                                                        <div className="text-center">
                                                            <button
                                                                type="submit"
                                                                style={{
                                                                    width: "100%",
                                                                    fontWeight: "600",
                                                                    background: "linear-gradient(to right, #6a11cb, #2575fc)",
                                                                    border: "none",
                                                                    padding: "10px 20px",
                                                                    borderRadius: "25px",
                                                                }}
                                                            >
                                                                Save
                                                            </button>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </Form>
                                        </TabPane> */}

                                        </TabContent>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                        <Row>
                            <Card>
                                <CardBody>
                                    <CardTitle className="mb-1"></CardTitle>
                                    <DatatableTables />
                                </CardBody>
                            </Card>
                        </Row>
                    </Container>
                </div>
            </React.Fragment>
        </AdminGuard>
    )
}

export default Addproperty
